import { render, staticRenderFns } from "./BannerSection.vue?vue&type=template&id=40d09dc5&scoped=true"
import script from "./BannerSection.vue?vue&type=script&lang=js"
export * from "./BannerSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d09dc5",
  null
  
)

export default component.exports